import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import moment from "moment";
import {FormWizard, TabContent} from "vue-form-wizard";
import VehicleList from "@/components/vehicle/list/VehicleList.vue";
import moduleMap from "@/store/map/moduleMap.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import ListSelectedVisitPoints from "@/components/optimization/visit-point/ListSelectedVisitPoints.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import {Validator} from "vee-validate";
import {en, es} from "vuejs-datepicker/src/locale";
import flatPickr from "vue-flatpickr-component";
import Datepicker from "vuejs-datepicker";
import DateUtils from "@/helpers/DateUtils.js";
import VisitPointListOptimization from "@/components/optimization/visit-point/VisitPointListOptimization.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointListDatarutas from "@/components/optimization/datarutas/visit-point/VisitPointList.vue";
import ResourceListDatarutas from "@/components/optimization/datarutas/resource/ResourceList.vue";
import Utils from "@/helpers/Utils";
import {v4 as uuidv4} from "uuid";
import DrawingTools from "@/components/optimization/DrawingTools.vue";
import GoogleMaps from "@/components/Maps/Maps.vue";
import UploadFile from "@/components/optimization/upload-file/UploadFile.vue";
import OptimizationCreate from "@/components/optimization/OptimizationCreate.vue";
import OptimizationErrors from "@/components/optimization/OptimizationErrors.vue";
import NotAuthorized from "@/components/optimization/datarutas/NotAuthorized.vue";
import moduleSessionApi from "@/store/session-api/moduleSessionApi";
import ListSelectVehicle from "@/components/optimization/resource/ListSelectVehicle.vue";
import windowScrollPosition from "@/plugins/window-scroll-position.js";
import {firebaseInstance as firebase} from "@/main";
import {GoogleMapsOverlay} from "@deck.gl/google-maps";
import {IconLayer} from "@deck.gl/layers";
import FloatingButtonsWizard from "@/views/FloatingButtonsWizard.vue";
import JobPlanningForm from "@/components/optimization/jobs/JobPlanningForm.vue";
import OptimizationTopTabs from "@/components/optimization/OptimizationTopTabs.vue";

export const OptimizationMixin = {
	name: "OptimizationComponent",
	mixins: [windowScrollPosition("position")],
	data() {
		return {
			active: true,
			init_date: new Date(),
			end_date: new Date(),
			init_hour: "00:00:00",
			end_hour: "23:59:59",
			langHe: es,
			langEn: en,
			errorsActive: false,
			optimizationErrors: [],
			activePrompt: false,
			isMounted: false,
			activeTabResource: false,
			activeTabVisitPoint: false,
			activeTab: 0,
			activeTabVehicle: 0,
			activeItem: "0",
			status_id: [],
			alertCode: false,
			gridApiVisitPointList: null,
			infoFile: null,
			maximize: false,
			shapeSelected: null,
			shapes: new Map(),
			circleList: [],
			polygonList: [],
			visitsPointDatarutas: [],
			isExecutedLayersDatarutas: false,
			showBtnDeleteShape: false,
			activePromptCheck: false,
			is_pickup: true,
			is_delivery: true,
			renderMountedVpsr: false,
			showOptimizationPeriod: true,
			isExactly: false,
			quantityElementPage: 20,
			dataOptimization: {},
			isDatarutasEnabled: false,
			showUploadFileOptimization: true,
			showSetEquivalenceOptimization: false,
			nameOptimizationCont: 0,
			infoWindow: new google.maps.InfoWindow(),
			overlay: new GoogleMapsOverlay({layers: []}),
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			paginationVehicles: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			paginationResourceDatarutas: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			vehicleListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: [
					"id",
					"identification",
					"profile",
					"max_travel_distance",
					"max_travel_duration",
					"init_depot_name",
					"end_depot_name",
				],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: true,
			},
			vehicleListConfigDatarutas: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: ["identification", "name", "lastname", "username", "email", "status", "typology_name"],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: true,
			},
			visitPointListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				showItemsPerPage: false,
				showPopup: true,
				showMaximizeBtn: true,
				showActions: true,
				cellRendererAdditionalFields: true,
				columns: [
					"id",
					"identification",
					"demand",
					"typeService",
					"address",
					"city",
					"department",
					"status_name",
					"additional_info",
					"isPickup",
					"isDelivery",
				],
			},
			visitPointListConfigDatarutas: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				showItemsPerPage: false,
				showPopup: true,
				showMaximizeBtn: true,
				showActions: true,
				cellRendererAdditionalFields: true,
				columns: [
					"id",
					"identification",
					"name",
					"address",
					"city",
					"department",
					"status_name",
					"isPickup",
					"isDelivery",
				],
			},
			activeDiscardedItemsPrompt: false,
			discardedItemsList: [],
			discardedItemsPerPage: 20,
			currentDiscardedItemsPage: 1,
		};
	},
	components: {
		FormWizard,
		TabContent,
		VuePerfectScrollbar,
		ListSelectedVisitPoints,
		vSelect,
		NotPermission,
		flatPickr,
		Datepicker,
		VisitPointListOptimization,
		VehicleList,
		VisitPointListDatarutas,
		ResourceListDatarutas,
		DrawingTools,
		GoogleMaps,
		UploadFile,
		OptimizationCreate,
		OptimizationErrors,
		NotAuthorized,
		ListSelectVehicle,
		FloatingButtonsWizard,
		JobPlanningForm,
		OptimizationTopTabs,
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleSessionApi.isRegistered) {
			this.$store.registerModule("moduleSessionApi", moduleSessionApi);
			moduleSessionApi.isRegistered = true;
		}
		// Create Custom Validators
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);
		this.$store.dispatch("moduleCommon/fetchDataSelectVisitPoint").then((res) => {
			this.status_id = res.data.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
		});
		this.isMounted = true;
		this.getVisitPoint(1);
		this.getVehicles(1);
		this.getSessionApiByToken();
	},
	computed: {
		OptimizationCreatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_C");
		},
		validFormPrompt() {
			return this.dataOptimization.nameOptimization != "";
		},
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsPickup;
		},
		getCheckedVisitPointsDelivery() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDelivery;
		},
		getCheckedVisitPointsPickupDatarutas() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas;
		},
		getCheckedVisitPointsDeliveryDatarutas() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas;
		},
		getCheckedVisitPointsPickupUploadFile() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup;
		},
		getCheckedVisitPointsDeliveryUploadFile() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery;
		},
		getCheckedVehicles() {
			return this.$store.state.vehicle.checkedVehicles === undefined ||
				this.$store.state.vehicle.checkedVehicles === "" ||
				this.$store.state.vehicle.checkedVehicles === null
				? []
				: this.$store.state.vehicle.checkedVehicles;
		},
		getCheckedResourceDatarutas() {
			return this.$store.state.vehicle.checkedResourceDatarutas === undefined ||
				this.$store.state.vehicle.checkedResourceDatarutas === "" ||
				this.$store.state.vehicle.checkedResourceDatarutas === null
				? []
				: this.$store.state.vehicle.checkedResourceDatarutas;
		},
		getCheckedVehicleUploadFile() {
			return this.$store.state.vehicle.checkedUploadFiles === undefined ||
				this.$store.state.vehicle.checkedUploadFiles === "" ||
				this.$store.state.vehicle.checkedUploadFiles === null
				? []
				: this.$store.state.vehicle.checkedUploadFiles;
		},
		visitPointsMarkers() {
			return this.$store.state.moduleMap.visitPointsMarkers;
		},
		visitPointsMarkersDatarutas() {
			return this.$store.state.moduleMap.visitPointsMarkersDatarutas;
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		selectedResources() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		getNameOptimization() {
			return this.$store.state.moduleOptimization.standardInputList["name"];
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
		selectedTypeVehicle() {
			return this.$store.state.moduleRoutingType.typeVehicle;
		},
		paintingVisitingPoints() {
			return async (data) => {
				if (!this.isExecutedLayersDatarutas) {
					await this.loadAndDisplayVisitPoints(data, "datarutas", false);
					this.isExecutedLayersDatarutas = true;
					return true;
				}
				return false;
			};
		},
		activeTabLabel() {
			if (this.activeTab === 0) return "Serviroutes";
			if (this.activeTab === 1) return "Datarutas";
			if (this.activeTab === 2) return "Upload";
			return "Serviroutes";
		},
		// Pagination computed properties for discarded items
		paginatedDiscardedItems() {
			const startIndex = (this.currentDiscardedItemsPage - 1) * this.discardedItemsPerPage;
			const endIndex = startIndex + this.discardedItemsPerPage;
			return this.discardedItemsList.slice(startIndex, endIndex);
		},
		totalDiscardedItemsPages() {
			return Math.ceil(this.discardedItemsList.length / this.discardedItemsPerPage);
		},
		showDiscardedItemsPagination() {
			return this.discardedItemsList.length > this.discardedItemsPerPage;
		},
	},
	watch: {
		activeItem(val) {
			if (val === "1") {
				this.activeTabResource = true;
			} else if (val === "0") {
				this.activeTabVisitPoint = true;
				setTimeout(() => {
					this.$refs.ListSelectedVisitPoint.initMap();
				}, 600);
			}
		},
		async activeTab(val) {
			this.infoFile = null;
			const setLayerVisibility = (layerId, isVisible) => {
				this.updateLayerVisibilityById(layerId, isVisible);
				const visibilityStatus = isVisible ? true : false;
				this.circleList.forEach((circle) => {
					if (circle.option_id === layerId) {
						circle.setVisible(visibilityStatus);
					}
				});
				this.polygonList.forEach((polygon) => {
					if (polygon.option_id === layerId) {
						polygon.setVisible(visibilityStatus);
					}
				});
			};
			const resetSelection = (ref) => {
				if (this.isModeSelected && this.$refs[ref]) {
					this.$refs[ref].removeChips();
				}
			};
			const handleDatarutasTab = async () => {
				this.maximize = !this.isDatarutasEnabled;

				if (this.isDatarutasEnabled) {
					resetSelection("visitPointListServiroute");
					setLayerVisibility("serviroutes", false);
					await this.paintingVisitingPoints(this.visitsPointDatarutas);
					setLayerVisibility("datarutas", true);
					Anuket.fitboundGeoJson(this.visitPointsMarkersDatarutas);
					Anuket.selectTool(null);
					this.showBtnDeleteShape = false;
				}
			};
			const handleServiroutesTab = () => {
				this.maximize = false;
				resetSelection("visitPointListDataruta");
				setLayerVisibility("serviroutes", true);
				setLayerVisibility("datarutas", false);
				Anuket.fitboundGeoJson(this.visitPointsMarkers);
				Anuket.selectTool(null);
				this.showBtnDeleteShape = false;
			};
			if (val === 1) {
				await handleDatarutasTab();
			} else if (val === 0) {
				handleServiroutesTab();
			}
		},
	},
	methods: {
		createIconLayer(id, data, visibility) {
			return new IconLayer({
				id,
				data: data.hasOwnProperty("features") ? data.features.filter((point) => point.properties.visible) : [],
				pickable: true,
				stroked: true,
				filled: true,
				visible: visibility,
				getIcon: () => ({
					url: Utils.addIconSvgWithMarker("111350", "⭐"),
					width: 40,
					height: 60,
				}),
				onClick: (info) => {
					if (info.object) {
						const coordinates = info.object.geometry.coordinates;
						const content = this.generateInfowindowContentVisitPoint(
							info.object.properties,
							this.infoWindow
						);
						this.infoWindow.setContent(content);
						this.infoWindow.setPosition(new google.maps.LatLng(coordinates[1], coordinates[0]));
						this.infoWindow.open(Anuket.getAnuketObj().map);
					}
				},
				sizeScale: 1,
				getPosition: (d) => d.geometry.coordinates,
				getSize: (d) => 30,
				getIconSize: (d) => [40, 60],
				zIndex: id === "serviroutes" ? 1 : 2,
			});
		},
		updateLayerVisibilityById(layerId, visibility) {
			// Obtener las capas actuales
			const layers = this.overlay.props.layers;
			// Encontrar el índice de la capa específica
			const index = layers.findIndex((layer) => layer.id === layerId);
			// Verificar si el índice es válido
			if (index !== -1) {
				// Clonar la capa y actualizar su visibilidad
				const updatedLayer = layers[index].clone({visible: visibility});
				// Crear una nueva lista de capas con la capa actualizada
				const updatedLayers = [
					...layers.slice(0, index), // Capas antes de la capa actual
					updatedLayer, // Capa actualizada
					...layers.slice(index + 1), // Capas después de la capa actual
				];
				// Actualizar la superposición con las capas modificadas
				this.overlay.setProps({layers: updatedLayers});
			} else {
				console.error(`Capa con ID '${layerId}' no encontrada`);
			}
		},
		updatePointsInLayer(id, data) {
			// Encontrar el índice de la capa correspondiente al id
			const layerIndex = this.overlay.props.layers.findIndex((layer) => layer.id === id);
			// Verificar si la capa existe
			if (layerIndex !== -1) {
				// Crear una nueva capa con los datos proporcionados
				const updatedLayer = this.createIconLayer(id, data, true);
				// Actualizar la capa en la lista de capas
				const updatedLayers = [
					...this.overlay.props.layers.slice(0, layerIndex), // Capas antes de la capa actual
					updatedLayer, // Capa actualizada
					...this.overlay.props.layers.slice(layerIndex + 1), // Capas después de la capa actual
				];
				// Establecer las capas actualizadas en la superposición
				this.overlay.setProps({layers: updatedLayers});
			} else {
				console.warn(`Capa con ID '${id}' no encontrada`);
			}
		},
		getStandardInput() {
			let vehicleList = {};
			let pickupsObject = {};
			let deliveryObject = {};
			if (this.getCheckedVisitPointsPickup.length > 0)
				pickupsObject["serviroutes_visit_point_ids"] = this.getCheckedVisitPointsPickup.map(({id}) => id);
			if (this.getCheckedVisitPointsPickupDatarutas.length > 0)
				pickupsObject["datarutas_visit_point_ids"] = this.getCheckedVisitPointsPickupDatarutas.map(
					({id}) => id
				);
			if (this.getCheckedVisitPointsPickupUploadFile.length > 0)
				pickupsObject["file_visit_point"] = this.getCheckedVisitPointsPickupUploadFile.map((data) => {
					delete data.isDelivery;
					delete data.isPickup;
					return data;
				});
			if (this.getCheckedVisitPointsDelivery.length > 0)
				deliveryObject["serviroutes_visit_point_ids"] = this.getCheckedVisitPointsDelivery.map(({id}) => id);
			if (this.getCheckedVisitPointsDeliveryDatarutas.length > 0)
				deliveryObject["datarutas_visit_point_ids"] = this.getCheckedVisitPointsDeliveryDatarutas.map(
					({id}) => id
				);
			if (this.getCheckedVisitPointsDeliveryUploadFile.length > 0)
				deliveryObject["file_visit_point"] = this.getCheckedVisitPointsDeliveryUploadFile.map((data) => {
					delete data.isDelivery;
					delete data.isPickup;
					return data;
				});
			const payload = {
				pickups: pickupsObject,
				deliveries: deliveryObject,
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.end_date, "YYYY-MM-DD"),
					init_hour: this.init_hour,
					end_hour: this.end_hour,
				},
			};
			if (this.getCheckedVehicles.length > 0)
				vehicleList["serviroutes_vehicle_ids"] = this.getCheckedVehicles.map(({id}) => id);
			if (this.getCheckedResourceDatarutas.length > 0)
				vehicleList["dararutas_resource_ids"] = this.getCheckedResourceDatarutas.map(({id}) => id);
			if (this.getCheckedVehicleUploadFile.length > 0)
				vehicleList["file_vehicle"] = this.getCheckedVehicleUploadFile;
			if (Object.entries(vehicleList).length > 0) payload.vehicles = vehicleList;
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/generateStandardInput", payload)
				.then((res) => {
					this.$vs.loading.close();
					// Check if there are discarded items due to frequencies
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP");
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINTS_OPTIMIZATION");
					this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY");
					this.$store.commit("vehicle/REMOVE_ALL_UPLOAD_FILE_VEHICLE");
					this.$store.commit("vehicle/REMOVE_ALL_CHECKED_UPLOAD_FILE_VEHICLE");
					this.activeTabVisitPoint = true;
					this.activeTabResource = true;
					this.showOptimizationPeriod = false;
					this.$refs.WizardShipment.removeTab(this.$refs.WizardShipment.tabs[1]);
					this.$refs.WizardShipment.removeTab(this.$refs.WizardShipment.tabs[0]);
					this.$refs.WizardShipment.nextTab();
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
						time: 7000,
					});
					console.error(err);
					return err;
				});
		},
		validateStep2() {
			let validateStep2Result = false;
			if ((this.infoFile && this.showUploadFileOptimization) || this.showSetEquivalenceOptimization) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: this.$t("UserHasAFileUploadProcessInPlace"),
					accept: () => {
						if (!this.showSetEquivalenceOptimization) this.$refs.uploadVehicleList.cleanData();
						this.showUploadFileOptimization = true;
						this.showSetEquivalenceOptimization = false;
						this.infoFile = null;
						this.getStandardInput();
					},
					cancel: () => {
						validateStep2Result = false;
					},
					acceptText: this.$t("Routing.ValidateMessages.Yes"),
					cancelText: this.$t("Routing.ValidateMessages.Not"),
				});
			} else {
				if (this.activeTabVehicle == 2) {
					if (this.showSetEquivalenceOptimization) this.$refs.uploadVehicleList.cleanData();
					this.showUploadFileOptimization = true;
					this.showSetEquivalenceOptimization = false;
				}
				validateStep2Result = true;
				this.getStandardInput();
			}
			this.activeTabResource = true;
			return validateStep2Result;
		},
		validateStep1() {
			let validateStep1Result = false;
			if ((this.infoFile && this.showUploadFileOptimization) || this.showSetEquivalenceOptimization) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: this.$t("UserHasAFileUploadProcessInPlace"),
					accept: () => {
						if (!this.showSetEquivalenceOptimization) this.$refs.uploadFilevisitPointList.cleanData();
						this.showUploadFileOptimization = true;
						this.showSetEquivalenceOptimization = false;
						this.alertCode = true;
						this.infoFile = null;
						this.$refs.WizardShipment.nextTab();
					},
					cancel: () => {
						validateStep1Result = false;
					},
					acceptText: this.$t("Routing.ValidateMessages.Yes"),
					cancelText: this.$t("Routing.ValidateMessages.Not"),
				});
			} else {
				if (this.activeTab == 2) {
					if (this.showSetEquivalenceOptimization) this.$refs.uploadFilevisitPointList.cleanData();
					this.showUploadFileOptimization = true;
					this.showSetEquivalenceOptimization = false;
				}
				validateStep1Result = true;
			}
			this.alertCode = true;
			return validateStep1Result;
		},
		validateBack() {
			if ((this.infoFile && this.showUploadFileOptimization) || this.showSetEquivalenceOptimization) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: this.$t("UserHasAFileUploadProcessInPlace"),
					accept: () => {
						if (!this.showSetEquivalenceOptimization) this.$refs.uploadVehicleList.cleanData();
						this.showUploadFileOptimization = true;
						this.showSetEquivalenceOptimization = false;
						this.$refs.WizardShipment.prevTab();
					},
					acceptText: this.$t("Routing.ValidateMessages.Yes"),
					cancelText: this.$t("Routing.ValidateMessages.Not"),
				});
			} else {
				this.$refs.WizardShipment.prevTab();
			}
		},
		acceptPrompt() {
			if (this.selectedRoutingType === "OPENROUTE" && !this.dataOptimization.hasOwnProperty("mesh")) {
				this.activePrompt = true;
				return;
			}
			this.generateOptimization();
		},
		closePrompt() {},
		showPrompt() {
			if (!this.$refs.WizardShipment.isLastStep && this.$refs.WizardShipment.activeTabIndex <= 1) {
				this.$refs.WizardShipment.nextTab();
			} else {
				const countPickup = this.standardInput.hasOwnProperty("pickups")
					? this.standardInput["pickups"].length
					: 0;
				const countDelivery = this.standardInput.hasOwnProperty("deliveries")
					? this.standardInput["deliveries"].length
					: 0;
				const countVehicles = this.standardInput.hasOwnProperty("vehicles")
					? this.standardInput["vehicles"].length
					: 0;
				if (countPickup + countDelivery <= 1) {
					this.$vs.notify({
						color: "warning",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("Optimization.ValidateOptimizationVisitpointText"),
						time: 9000,
					});
					return;
				}
				if (countVehicles <= 0) {
					this.$vs.notify({
						color: "warning",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("Optimization.ValidateOptimizationResourceText"),
						time: 9000,
					});
					return;
				}
				this.dataOptimization = {
					nameOptimization: this.getNameOptimization,
					selectedRouter: this.selectedRoutingType,
					selectedVehicleProfile: this.selectedTypeVehicle,
					profileOption: "general",
					period: {
						init_date: moment(this.standardInput["global_config"].init_date).format(),
						end_date: moment(this.standardInput["global_config"].end_date).format(),
						init_hour: this.standardInput["global_config"].init_hour,
						end_hour: this.standardInput["global_config"].end_hour,
					},
				};
				this.activePrompt = true;
			}
		},
		generateOptimization() {
			this.$validator.validateAll("create-optimization").then((isValid) => {
				if (!isValid) {
					this.showValidationError();
					return;
				}
				this.prepareResources();
				const payload = this.buildPayload();
				this.showLoadingWizard();
				this.$store
					.dispatch("moduleOptimization/optimization", payload)
					.then((res) => this.handleOptimizationResponse(res))
					.catch((err) => {
						this.handleOptimizationError(err);
					});
			});
		},
		showValidationError() {
			this.activePrompt = true;
			this.$vs.notify({
				color: "warning",
				title: this.$t("ErrorFields.Title"),
				text: this.$t("ErrorFields.Text"),
			});
		},
		prepareResources() {
			switch (this.selectedRoutingType) {
				case "OPENROUTE":
					this.removeProperties(this.selectedResources, ["max_travel_duration", "max_travel_distance"]);
					break;
				case "GMPRO":
					this.removeProperties(this.standardInput["pickups"], ["priority"]);
					this.removeProperties(this.standardInput["deliveries"], ["priority"]);
					break;
				case "TOUR_PLANNING":
					this.removeProperties(this.selectedResources, ["max_travel_duration", "time_window"]);
					this.adjustTimeService(this.standardInput["pickups"]);
					this.adjustTimeService(this.standardInput["deliveries"]);
					break;
			}
		},
		removeProperties(items, properties) {
			items.forEach((item) => {
				properties.forEach((prop) => delete item[prop]);
			});
		},
		adjustTimeService(items) {
			if (items) {
				items.forEach((item) => {
					if (item.time_service === "00:00:00") {
						item.time_service = "00:00:01";
					}
				});
			}
		},
		buildPayload() {
			const payload = {
				name: this.dataOptimization.nameOptimization,
				vehicles: this.standardInput["vehicles"],
				routing_api: this.selectedRoutingType,
				deliveries: this.standardInput["deliveries"],
				pickups: this.standardInput["pickups"],
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.end_date, "YYYY-MM-DD"),
					init_hour: this.dataOptimization.period.init_hour,
					end_hour: this.dataOptimization.period.end_hour,
				},
			};

			if (this.standardInput.hasOwnProperty("jobs") && this.standardInput["jobs"].length > 0) {
				payload.jobs = this.standardInput["jobs"];
			}

			if (this.dataOptimization.group) {
				payload.optimization_group_id = this.dataOptimization.group.value;
			}

			if (this.selectedRoutingType === "OPENROUTE") {
				payload.global_config.mesh = this.dataOptimization.mesh.value;
			}

			if (this.selectedRoutingType === "TOUR_PLANNING" || this.selectedRoutingType === "GMPRO") {
				if (this.dataOptimization.objectiveListSelected && this.dataOptimization.objectiveListSelected.length) {
					payload.global_config.objectives = this.dataOptimization.objectiveListSelected.map(
						(data) => data.value
					);
				}
			}

			if (this.selectedRoutingType === "TOUR_PLANNING") {
				payload.global_config.live_traffic = this.dataOptimization.liveTraffic;
				if (this.dataOptimization.advanced_objectives && this.dataOptimization.advanced_objectives.length) {
					payload.global_config.advanced_objectives = this.dataOptimization.advanced_objectives;
				}
			}

			if (
				this.dataOptimization.hasOwnProperty("profileOption") &&
				this.dataOptimization.profileOption === "general"
			) {
				payload.global_config.global_profile = this.dataOptimization.selectedVehicleProfile;
			}

			return payload;
		},
		showLoadingWizard() {
			this.$vs.loading({
				container: "#wizard-with-loading-optimization",
				text: this.$t("ValidatingTheInformationProvided"),
			});
		},
		handleOptimizationResponse(res) {
			if (res.data.status === 400 || res.data.optimizer.status === 400) {
				this.processOptimizationErrors(res);
				return;
			}
			this.$store.commit("moduleOptimization/DELETE_ALL_ERROR_OPTIMIZATION");
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
			this.$router.push({name: "OptimizationList"});
		},
		processOptimizationErrors(res) {
			this.optimizationErrors = [];
			const addErrorDetails = (errors) => {
				errors.forEach((err) => {
					const absolutePath = err.absolute_path.join("/");
					this.optimizationErrors.push({message: err.validator || err.message, absolutePath});
				});
			};
			if (res.data.optimizer.data) addErrorDetails(res.data.optimizer.data);
			if (res.data.optimizer.error) addErrorDetails(res.data.optimizer.error);
			if (res.data.errors.length) {
				this.addIndexToPoints("pickups");
				this.addIndexToPoints("deliveries");
				this.$store.commit("moduleOptimization/SET_ERROR_OPTIMIZATION", res.data.errors);
			}
			this.selectedResources.forEach((resource, index) => (resource.indexResource = index));
			this.errorsActive = true;
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
		},
		addIndexToPoints(type) {
			if (this.standardInput[type].length) {
				this.standardInput[type].forEach((point, index) => (point.indexVisitPoint = index));
			}
		},
		handleOptimizationError(err) {
			console.error(err);
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh = typeof this.end_date === "string" ? new Date(this.end_date).getTime() : this.end_date.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.init_date === "string" ? new Date(this.init_date).getTime() : this.init_date.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			const dateInit =
				typeof this.init_date === "string" ? new Date(this.init_date).getTime() : this.init_date.getTime();
			const dateEnd =
				typeof this.end_date === "string" ? new Date(this.end_date).getTime() : this.end_date.getTime();
			if (this.init_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.init_hour);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			const dateInit =
				typeof this.init_date === "string" ? new Date(this.init_date).getTime() : this.init_date.getTime();
			const dateEnd =
				typeof this.end_date === "string" ? new Date(this.end_date).getTime() : this.end_date.getTime();
			if (this.end_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.end_hour);
		},
		async getVisitPointDatarutas(page, isLoginDatarutas) {
			const payload = {
				page,
				sort: "desc",
				order_by: ["id"],
			};
			this.$vs.loading();
			await this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", payload)
				.then(async (res) => {
					res.records.map((item) => (item.visible = true));
					if (isLoginDatarutas) {
						this.updateLayerVisibilityById("serviroutes", false);
						await this.paintingVisitingPoints(res.records);
						this.updateLayerVisibilityById("datarutas", true);
						this.isExecutedLayersDatarutas = true;
					} else {
						this.visitsPointDatarutas = res.records;
					}
					this.$vs.loading.close();
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
				});
		},
		getVisitPoint(page) {
			const payload = {
				page,
				sort: "desc",
				status_id: this.status_id,
				order_by: ["id"],
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginated", payload)
				.then(async (res) => {
					res.records.map((item) => (item.visible = true));
					if (res.records.length > 0) {
						this.loadAndDisplayVisitPoints(res.records, "serviroutes", true);
					} else {
						this.$vs.loading.close();
					}
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
				});
		},
		async loadAndDisplayVisitPoints(data, option_id, visibility) {
			// Mostrar cargador inicial
			this.showLoading();
			// Inicializar herramientas de dibujo y selección en el mapa
			this.initializeAnuketTools();
			// Preparar el payload y realizar la solicitud
			const payload = {data};
			await this.$store
				.dispatch("moduleMap/convertJsonToGeojson", payload)
				.then(async (res) => {
					const geojson = res.data[0].geojson;
					// Crear y agregar una nueva capa de iconos
					await this.addIconLayer(option_id, geojson, visibility);
					// Guardar los puntos de visita según el tipo de opción
					this.saveVisitPoints(option_id, geojson);
					setTimeout(
						async () => {
							Anuket.fitboundGeoJson(geojson);
							this.closeLoading();
						},
						geojson.features.length > 6000 ? 6000 : 1000
					);
				})
				.catch((error) => {
					this.closeLoading();
					console.error(error);
				});
		},
		showLoading() {
			this.$vs.loading();
			this.$vs.loading({
				container: "#google-map-loading",
				text: this.$t("LoadingVisitPoints") + "...",
				type: "point",
				scale: 1,
				background: "rgba(255, 255, 255, .6)",
			});
		},
		closeLoading() {
			this.$vs.loading.close();
			this.$vs.loading.close(`#google-map-loading > .con-vs-loading`);
		},
		initializeAnuketTools() {
			Anuket.initToolDrawingManager(this.callbackDraw, this.callbacClick);
			Anuket.selectTool(null);
		},
		async addIconLayer(option_id, geojson, visibility) {
			let updatedLayers = [];
			if (option_id === "serviroutes") {
				const newLayerServiroutes = await this.createIconLayer(option_id, geojson, visibility);
				updatedLayers = [newLayerServiroutes];
			}
			if (option_id === "datarutas") {
				const currentLayers = this.overlay.props.layers || [];
				const newLayerDatarutas = await this.createIconLayer(option_id, geojson, visibility);
				updatedLayers = [...currentLayers, newLayerDatarutas];
			}
			this.overlay.setMap(Anuket.getAnuketObj().map);
			this.overlay.setProps({layers: updatedLayers});
		},
		saveVisitPoints(option_id, geojson) {
			if (option_id === "serviroutes") {
				this.$store.commit("moduleMap/SAVE_VISIT_POINT_MARKER", geojson);
			} else if (option_id === "datarutas") {
				this.$store.commit("moduleMap/SAVE_VISIT_POINT_MARKER_DATARUTAS", geojson);
			}
		},
		async getVehiclesDatarutas(page) {
			const payload = {
				page,
				quantity: this.quantityElementPage,
				role_name: ["EXECUTIVE", "SUPERVISOR"],
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("vehicle/fetchDatarutasResource", payload)
				.then((res) => {
					Object.assign(this.paginationResourceDatarutas, res.pagination);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getVehicles(page) {
			const payload = {
				page,
				quantity: this.quantityElementPage,
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			this.$store
				.dispatch("vehicle/findVehiclePaginated", payload)
				.then((res) => {
					Object.assign(this.paginationVehicles, res.pagination);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showSelectedVisitsPoint(visitPoints) {
			if (this.activeTab === 1) {
				this.visitPointsMarkersDatarutas.features.forEach((marker) => {
					const valid = visitPoints.some((r) => r.identification === marker.properties.identification);
					marker.properties.visible = valid;
				});
				this.updatePointsInLayer("datarutas", this.visitPointsMarkersDatarutas);
			} else {
				this.visitPointsMarkers.features.forEach((marker) => {
					const valid = visitPoints.some((r) => r.identification === marker.properties.identification);
					marker.properties.visible = valid;
				});
				this.updatePointsInLayer("serviroutes", this.visitPointsMarkers);
			}
		},
		handleMaximize() {
			this.maximize = !this.maximize;
		},
		callbacClick(shape) {
			if (this.shapeSelected) {
				this.shapeSelected.setOptions({strokeWeight: 1});
			}
			this.shapeSelected = shape;
			this.shapeSelected.setOptions({strokeWeight: 3});
			this.showBtnDeleteShape = true;
		},
		callbackDraw(shape) {
			if (this.shapeSelected) {
				this.shapeSelected.setOptions({strokeWeight: 1});
			}
			if (this.activeTab === 0) {
				shape.option_id = "serviroutes";
			} else {
				shape.option_id = "datarutas";
			}
			shape["id"] = uuidv4();
			this.shapes.set(shape.id, shape);
			this.shapeSelected = shape;
			switch (shape.type) {
				case "polygon":
					const vertices = shape.getPath();
					let coordinates = [];
					vertices.forEach((vertice) => {
						const arr = [vertice.lng(), vertice.lat()];
						coordinates.push(arr);
					});
					coordinates.push(coordinates[0]);
					this.coordinatesPolygon = coordinates;
					this.polygonList.push(shape);
					this.activePromptCheck = true;
					break;
				case "circle":
					this.circleList.push(shape);
					this.activePromptCheck = true;
					break;
				default:
					break;
			}
		},
		deleteShape() {
			if (this.shapeSelected === null) {
				return;
			}
			if (this.shapeSelected.hasOwnProperty("arrayVisitPoint")) {
				for (let visitPoint of this.shapeSelected.arrayVisitPoint) {
					this.gridApiVisitPointList.forEachNode((node) => {
						if (visitPoint.id === node.data.id) {
							node.setDataValue("isPickup", false);
							node.setDataValue("isDelivery", false);
						}
					});
					if (this.activeTab === 0) {
						this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_PICKUP", visitPoint);
						this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_DELIVERY", visitPoint);
					} else if (this.activeTab === 1) {
						this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_PICKUP_DATARUTAS", visitPoint);
						this.$store.commit(
							"moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS",
							visitPoint
						);
					}
				}
			}
			this.shapeSelected.setMap(null);
			this.shapes.delete(this.shapeSelected.id);
			this.shapeSelected = null;
		},
		getModeSelected(val) {
			this.isModeSelected = val;
		},
		getGridApi(gridApi) {
			this.gridApiVisitPointList = gridApi;
		},
		getMountedVisitPointList(value) {
			this.renderMountedVpsr = value;
		},
		acceptAlertCheck() {
			if (this.shapeSelected.type === "polygon") {
				if (this.activeTab === 0) {
					this.$refs.visitPointListServiroute.validateMarkerSelectionPolygon(
						this.shapeSelected,
						this.is_pickup,
						this.is_delivery
					);
				} else if (this.activeTab === 1) {
					this.$refs.visitPointListDataruta.validateMarkerSelectionPolygon(
						this.shapeSelected,
						this.is_pickup,
						this.is_delivery
					);
				}
			} else if (this.shapeSelected.type === "circle") {
				if (this.activeTab === 0) {
					this.$refs.visitPointListServiroute.validateMarkerSelectionCircle(
						this.shapeSelected,
						this.is_pickup,
						this.is_delivery
					);
				} else if (this.activeTab === 1) {
					this.$refs.visitPointListDataruta.validateMarkerSelectionCircle(
						this.shapeSelected,
						this.is_pickup,
						this.is_delivery
					);
				}
			}
		},
		closePromptCheck() {
			this.is_pickup = true;
			this.is_delivery = true;
			this.deleteShape();
		},
		generateInfowindowContentVisitPoint({address, city, identification, name}, infowindow) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify;";
			let $headerInfoWindowContent = document.createElement("div");
			$headerInfoWindowContent.className = "flex items-center justify-between";
			let $closeButton = document.createElement("button");
			$closeButton.textContent = "X";
			$closeButton.className = "bg-primary text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
			$closeButton.addEventListener("click", () => {
				infowindow.close();
			});
			let $title = document.createElement("h4");
			let $subtitle = document.createElement("p");
			$title.textContent = this.$t("VisitPoint");
			$subtitle.innerHTML = `<strong>${this.$t("Identification")}</strong>: ${
				identification === null ? "-" : identification
			} `;
			let $visitPoint = document.createElement("p");
			let $address = document.createElement("p");
			$visitPoint.innerHTML = `<strong>${this.$t("City")}</strong>: ${city}`;
			$address.innerHTML = `<strong>${this.$t("Address")}</strong>: ${address}`;
			$docFragment.appendChild($subtitle);
			$docFragment.appendChild($visitPoint);
			$docFragment.appendChild($address);
			$headerInfoWindowContent.appendChild($title);
			$headerInfoWindowContent.appendChild($closeButton);
			$infowindowDivContent.appendChild($headerInfoWindowContent);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		acceptPromptPeriod() {
			this.$refs.WizardShipment.nextTab();
		},
		getDataFile(val) {
			this.infoFile = val;
		},
		optimizationFields(data) {
			this.dataOptimization = data;
		},
		activePopup(val) {
			this.errorsActive = val;
		},
		getSessionApiByToken() {
			const token = localStorage.getItem("accessToken");
			this.$store
				.dispatch("moduleSessionApi/getSessionApiByToken", token)
				.then(async (response) => {
					if (response.data.hasOwnProperty("datarutas_company_id")) {
						this.isDatarutasEnabled = true;
						this.maximize = false;
						this.getVisitPointDatarutas(1, false);
						this.getVehiclesDatarutas(1);
					}
				})
				.catch((error) => console.error(error));
		},
		async loginDatarutas() {
			await firebase.auth().signInAnonymously();
			this.openLoadingInDiv("#div-with-loading", this.$t("Login.ConnectingWithDatarutas"));
			this.$store
				.dispatch("moduleOptimization/datarutasLogin")
				.then((response) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					if (response.status === 200 && response.data.hasOwnProperty("datarutas_company_id")) {
						this.isDatarutasEnabled = true;
						this.maximize = false;
						this.getVisitPointDatarutas(1, true);
						this.getVehiclesDatarutas(1);
						this.$vs.notify({
							color: "success",
							title: this.$t("Login.Login") + " " + "Datarutas",
							text: this.$t("Login.YouHaveSuccessfullyLoggedInToDatarutas"),
							time: 9000,
						});
					} else {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Login.Login") + " " + "Datarutas",
							text: this.$t("Login.CouldNotConnectToDatarutas"),
							time: 9000,
						});
					}
				})
				.catch((err) => {
					this.$vs.loading.close("#div-with-loading > .con-vs-loading");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Login.Login") + " " + "Datarutas",
						text: this.$t("Login.CouldNotConnectToDatarutas"),
						time: 9000,
					});
					console.error(err);
				});
		},
		setUploadFileOptimization(val) {
			this.showUploadFileOptimization = val;
		},
		setEquivalenceOptimization(val) {
			this.showSetEquivalenceOptimization = val;
		},
		openLoadingInDiv(container, text) {
			this.$vs.loading({
				container,
				scale: 0.6,
				text,
				textAfter: true,
				type: "point",
			});
		},
		onBack() {
			this.$refs.WizardShipment.prevTab();
		},
		handleTopTabChange(tab) {
			if (tab === "Serviroutes") this.activeTab = 0;
			else if (tab === "Datarutas") this.activeTab = 1;
			else if (tab === "Upload") this.activeTab = 2;
		},
		showDiscardedItemsPrompt(discardedItems) {
			// Parse and translate the discarded items
			const translatedItems = discardedItems.map((item) => {
				// Parse the item string: "TYPE identifier, discarded due to frequencies."
				const parts = item.split(",");
				if (parts.length >= 2) {
					const typeAndIdentifier = parts[0].trim();
					// Split type and identifier
					const spaceIndex = typeAndIdentifier.indexOf(" ");
					if (spaceIndex !== -1) {
						const type = typeAndIdentifier.substring(0, spaceIndex).trim();
						const identifier = typeAndIdentifier.substring(spaceIndex + 1).trim();
						// Translate the type
						let translatedType = type;
						if (type === "PICKUP") {
							translatedType = this.$t("Frequency.DiscardedItems.Pickup");
						} else if (type === "DELIVERY") {
							translatedType = this.$t("Frequency.DiscardedItems.Delivery");
						} else if (type === "VEHICLE") {
							translatedType = this.$t("Frequency.DiscardedItems.Vehicle");
						}
						return `${translatedType} ${identifier}`;
					}
				}
				return item; // Return original if parsing fails
			});

			// Store the translated items and activate the prompt
			this.discardedItemsList = translatedItems;
			this.currentDiscardedItemsPage = 1; // Reset to first page
			this.activeDiscardedItemsPrompt = true;
		},
		// Pagination methods for discarded items
		changeDiscardedItemsPage(page) {
			if (page >= 1 && page <= this.totalDiscardedItemsPages) {
				this.currentDiscardedItemsPage = page;
			}
		},
		closeDiscardedItemsPrompt() {
			this.activeDiscardedItemsPrompt = false;
			this.currentDiscardedItemsPage = 1;
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP_DATARUTAS");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINTS_OPTIMIZATION");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_UPLOAD_FILE_VISIT_POINT_CHECKED_DELIVERY");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_PICKUP");
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_DELIVERY");
		this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED");
		this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED_DATARUTAS");
		this.$store.commit("vehicle/REMOVE_ALL_UPLOAD_FILE_VEHICLE");
		this.$store.commit("vehicle/REMOVE_ALL_CHECKED_UPLOAD_FILE_VEHICLE");
		this.$store.commit("moduleOptimization/DELETE_ALL_ERROR_OPTIMIZATION");
		this.overlay = [];
	},
};
